module.exports = __webpack_public_path__ + "static/img/5@2x.c1c0356.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/home/5@2x.png
// module id = FMD7
// module chunks = 8